import { render, staticRenderFns } from "./createCoordination.modal.vue?vue&type=template&id=e25b8b6e&scoped=true"
import script from "./createCoordination.modal.vue?vue&type=script&lang=js"
export * from "./createCoordination.modal.vue?vue&type=script&lang=js"
import style0 from "./createCoordination.modal.vue?vue&type=style&index=0&id=e25b8b6e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e25b8b6e",
  null
  
)

export default component.exports